// @ecliptica/api-client — cliente tipado da API (hc<AppType>), usado pelo site, backoffice e gpu-worker.
// Os tipos vêm diretamente das rotas do backend: mudar uma rota parte a compilação de quem a usa.
import type { AppType } from "@ecliptica/backend";
import { hc } from "hono/client";

export function createApiClient(baseUrl: string) {
  return hc<AppType>(baseUrl, { init: { credentials: "include" } });
}

export type ApiClient = ReturnType<typeof createApiClient>;
